import { isPlatformServer } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { catchError, delay, map, Observable, throwError } from 'rxjs';
import { tokenServer } from '../_authentication/api-authorize.service';
import { StateService } from '../_services/state.service';

const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  token = '';

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private _stateService: StateService,
  ) {
    this._stateService.token$.subscribe({
      next: (token: string) => {
        this.token = token;
      },
    });
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      headers: request.headers.set(TOKEN_HEADER_KEY, `Bearer ` + (this.token || tokenServer)),
    });
    if (isPlatformServer(this.platformId)) {
      if (request.url.indexOf('//') === 0 || request.url.indexOf('http://') === 0 || request.url.indexOf('https://') === 0) {
        // Todo
      } else if (request.url.indexOf('/') === 0) {
        request = request.clone({
          url: `${location.protocol}://${location.host}/${request.url.replace('/', '')}`,
        });
      } else if (request.url.indexOf('./') === 0) {
        request = request.clone({
          url: `${location.protocol}://${location.host}/${request.url.replace('./', '')}`,
        });
      }
    }
    return next.handle(request).pipe(
      delay(0),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      map((event: HttpEvent<any>) => {
        return event;
      }),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      catchError((error: any) => {
        return throwError(error);
      }),
    );
  }
}

export const AuthInterceptorProviders = [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }];
